import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { ref, watchEffect } from 'vue';
import { dockState, switchTab, closeTab, setHeight } from '../utils/dock-state';


export default /*@__PURE__*/_defineComponent({
  __name: 'EpinioDock',
  setup(__props) {

const dockEl = ref<any>(null);

function setDockRef(el: any) {
  dockEl.value = el;
}

// Set properties directly on the element rather than via :tabs/:active-tab
// template bindings. Vue's kebab-case attribute fallback for custom elements
// doesn't reach camelCase Lit properties, this bit us before on action-menu's
// renderActions, doing it this way avoids the same issue here.
let wmHeightRafScheduled = false;

watchEffect(() => {
  if (!dockEl.value) {
    return;
  }

  dockEl.value.open = dockState.open;
  dockEl.value.activeTab = dockState.activeTab;
  dockEl.value.height = dockState.height;
  dockEl.value.tabs = dockState.tabs.map((tab) => ({
    id:    tab.id,
    label: tab.label,
    icon:  tab.icon,
  }));

  // Shell's page grid sizes the dock's row/column via the --wm-height/--wm-width
  // custom properties (see @rancher/shell's _layout.scss), previously only ever
  // set by Shell's own WindowManager. Since EpinioDock replaces WindowManager
  // for this product, it has to own setting them too, or the dock's grid cell
  // stays 0px and clips it regardless of what the dock itself renders.
  //
  // Unlike the property assignments above, this forces a full-page reflow
  // (it drives grid-template-rows on the root layout grid, not just the
  // dock's own box), so it's throttled to once per animation frame instead
  // of once per raw pointermove, which can fire faster than the page can
  // actually repaint and was visibly lagging behind the drag.
  if (!wmHeightRafScheduled) {
    wmHeightRafScheduled = true;

    requestAnimationFrame(() => {
      wmHeightRafScheduled = false;
      // Read dockState fresh here, not at schedule time, watchEffect may
      // have re-run several times (and skipped scheduling) before this fires.
      document.documentElement.style.setProperty('--wm-height', dockState.open ? `${ dockState.height }px` : '0px');
    });
  }
});

function onTabSwitch(e: Event) {
  switchTab((e as CustomEvent).detail.id);
}

function onTabClose(e: Event) {
  closeTab((e as CustomEvent).detail.id);
}

function onResize(e: Event) {
  setHeight((e as CustomEvent).detail.height);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-dock", {
    ref: setDockRef,
    onDockTabSwitch: onTabSwitch,
    onDockTabClose: onTabClose,
    onDockResize: onResize
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dockState).tabs, (tab) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component), _mergeProps({
        key: tab.id
      }, { ref_for: true }, tab.props, {
        slot: `tab:${tab.id}`
      }), null, 16, ["slot"]))
    }), 128))
  ], 32))
}
}

})